import { type HTMLAttributes, forwardRef } from 'react'

import { cn } from '@/lib/utils'

/**
 * Plain surface card. Same role as the driver `Card` but with a
 * tighter border-radius (8px instead of 16px) — desktop UIs read
 * "softer" with smaller corners on dense layouts.
 */
export const Card = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  function Card({ className, ...props }, ref) {
    return (
      <div
        ref={ref}
        className={cn(
          'bg-surface rounded-lg border border-surface-border shadow-sm',
          className,
        )}
        {...props}
      />
    )
  },
)

export function CardHeader({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('px-4 py-3 border-b border-surface-border', className)} {...props} />
  )
}

export function CardContent({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-4', className)} {...props} />
}

export function CardFooter({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'px-4 py-3 border-t border-surface-border flex items-center justify-end gap-2',
        className,
      )}
      {...props}
    />
  )
}
